import { render, staticRenderFns } from "./detailPreview.vue?vue&type=template&id=066f62be&scoped=true"
import script from "./detailPreview.vue?vue&type=script&lang=js"
export * from "./detailPreview.vue?vue&type=script&lang=js"
import style0 from "./detailPreview.vue?vue&type=style&index=0&id=066f62be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066f62be",
  null
  
)

export default component.exports